import React, { useState, useEffect, useMemo } from 'react';
import _ from 'underscore';

import { searchAppointments } from 'utils/AppointmentWebAPIUtils';
import AutoCompleteSearch from 'components/site/autocomplete-search';
import AppointmentStatus from './AppointmentStatus';

const renderAppointment = (appointment, label) => {
  return (
    <a
      key={appointment._id}
      id={appointment._id}
      className="list-group-item cursor-pointer"
    >
      <div className="flex">
        <div style={{ minWidth: 80 }}>
          <AppointmentStatus status={appointment.status} />
        </div>
        <span className="form-label px-2">{label}</span>
      </div>
    </a>
  );
};

/*
 * An autocomplete component for searching appointments
 */
export default function AppointmentSearchFilter({
  searchField,
  placeholder,
  onSelect,
}) {
  const [query, setQuery] = useState({});
  const [appointments, setAppointments] = useState([]);

  function onSearch(nGram) {
    setQuery({ ...query, [searchField]: nGram });
  }

  const debouncedQuery = useMemo(() => {
    return _.debounce(async (query) => {
      const appointments = await searchAppointments(query);
      setAppointments(_.sortBy(appointments, searchField));
    }, 350);
  }, []);

  useEffect(() => {
    if (!_.isEmpty(query)) {
      debouncedQuery(query, searchField);
    }
  }, [query]);

  return (
    <div>
      <AutoCompleteSearch
        onSearch={onSearch}
        onSelect={onSelect}
        items={appointments}
        placeholder={placeholder}
        renderItem={(item) => renderAppointment(item, item[searchField])}
      />
    </div>
  );
}
